import React from 'react';
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from '../../ui/breadcrumbs';
import { Link } from 'react-router-dom';

/**
 * Outer layout wrapper used for every admin screen in the prototype.
 *
 * Sets the same page-level padding, optional page title and breadcrumb as the
 * real admin shell. Does not render the real Sidebar/Navbar; the prototype nav
 * handles wayfinding in its own left rail.
 */
const AdminShell = ({ eyebrow, title, description, breadcrumbs, actions, children }) => {
  return (
    <div className='min-h-screen bg-background'>
      <div className='max-w-[1240px] mx-auto px-6 md:px-10 py-8'>
        {breadcrumbs && breadcrumbs.length > 0 && (
          <Breadcrumb className='mb-4'>
            <BreadcrumbList>
              {breadcrumbs.map((crumb, i) => {
                const isLast = i === breadcrumbs.length - 1;
                return (
                  <React.Fragment key={`${crumb.label}-${i}`}>
                    <BreadcrumbItem>
                      {isLast || !crumb.to ? (
                        <BreadcrumbPage>{crumb.label}</BreadcrumbPage>
                      ) : (
                        <BreadcrumbLink asChild>
                          <Link to={crumb.to}>{crumb.label}</Link>
                        </BreadcrumbLink>
                      )}
                    </BreadcrumbItem>
                    {!isLast && <BreadcrumbSeparator />}
                  </React.Fragment>
                );
              })}
            </BreadcrumbList>
          </Breadcrumb>
        )}

        <div className='flex flex-col md:flex-row md:items-start md:justify-between gap-4 mb-6'>
          <div>
            {eyebrow && (
              <div className='flex items-center gap-2 mb-2'>
                <div className='w-6 h-px bg-primary' />
                <span className='font-mono text-[10px] tracking-[0.18em] uppercase text-primary'>{eyebrow}</span>
              </div>
            )}
            {title && <h1 className='font-display text-3xl text-foreground leading-tight'>{title}</h1>}
            {description && (
              <p className='text-[15px] text-muted-foreground max-w-[640px] leading-relaxed mt-2'>{description}</p>
            )}
          </div>
          {actions && <div className='flex items-center gap-2 flex-wrap'>{actions}</div>}
        </div>

        {children}
      </div>
    </div>
  );
};

export default AdminShell;
